import { Sensor } from '../models';
import { Sensor as SensorEntity } from 'adc-sirius-module-common';
import { urls } from '../utilities/dataHelpers';
import {
  mapSensorEntityToSensor,
  mapSensorToSensorEntity,
} from '../utilities/mappers';
import mediator, { MediatorRequestWithResponse } from '../utilities/mediator';

const handleGetSensors = (request: MediatorRequestWithResponse<Sensor[]>) => {
  const subjectKey = request.subjectKey;

  request.response = new Promise((resolve, reject) => {
    mediator
      .request<SensorEntity[]>('api:invoke', {
        method: 'GET',
        url: `${urls.api}sensors/subject/${subjectKey}`,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve((result.data ?? []).map(mapSensorEntityToSensor));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error fetching sensors:', err);
        reject(err);
      });
  });
};

const handleGetSensorByKey = (request: MediatorRequestWithResponse<Sensor>) => {
  request.response = new Promise((resolve, reject) => {
    const sensorId = request.key;

    mediator
      .request<SensorEntity>('api:invoke', {
        method: 'GET',
        url: `${urls.api}sensors/${sensorId}`,
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(mapSensorEntityToSensor(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error fetching sensor by ID:', err);
        reject(err);
      });
  });
};

const handleUpdateSensor = (request: MediatorRequestWithResponse<Sensor>) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<SensorEntity>('api:invoke', {
        method: 'PUT',
        url: `${urls.api}sensors`,
        data: mapSensorToSensorEntity(request.data),
      })
      .then((result) => {
        if (result.status === 200) {
          resolve(mapSensorEntityToSensor(result.data));
        } else {
          reject(result);
        }
      })
      .catch((err) => {
        console.error('Error updating sensor:', err);
        reject(err);
      });
  });
};

mediator.subscribe('sensor:getSensors', handleGetSensors);
mediator.subscribe('sensor:getSensorByKey', handleGetSensorByKey);
mediator.subscribe('sensor:updateSensor', handleUpdateSensor);
